import 'mdn-polyfills/Object.keys';
import 'mdn-polyfills/Object.values';
import 'mdn-polyfills/String.prototype.repeat';

if (!console.table) {
  console.table = function(arr) {
    'use strict';
    
    if (!(arr instanceof Array) || arr.length === 0) {
      return console.log(arr);
    }
    
    let keys             = Object.keys(arr[0]);
    const horizontalLine = '\r\n' + '-'.repeat(8 * keys.length) + '\r\n';
    let heading          = Object.keys(arr[0]).join('\t');
    
    let str = horizontalLine;
    str += heading;
    
    arr.forEach(function(obj) {
      str += horizontalLine + Object.values(obj).join('\t\t');
    });
    str += horizontalLine;
    console.log('%c' + str, 'font-family: monospace');
  };
}